import { create } from 'zustand';
import { redirectHome } from '../../utils/navigation';

export interface B2CAuthUser {
  UserId?: string;
  FullName?: string;
  Email?: string;
  ProfileImage?: string;
  WalletBalance?: number;
}

export interface ApplyCreditResponse {
  UserId: string;
  DiscountId: number;
  Amount: number;
  HasUsedDiscount: boolean;
}

interface AuthStoreState {
  isLoggedIn: boolean;
  showAuthModal: boolean;
  showOTPModal: boolean;
  creditApplied: boolean;
  creditAmount: number;
  creditLoading: boolean;
  creditDetails: null | ApplyCreditResponse;
  setAuthModal: (show: boolean) => void;
  setOTPModal: (show: boolean) => void;
  login: () => void;
  logout: () => void;
  setCreditLoading: (loading: boolean) => void;
  setCreditAppliedDetails: (details: ApplyCreditResponse) => void;
  clearCreditDetails: () => void;
  removeCredit: () => void;
  // New additions for storing B2C User details, their own accesstoken, set their 
  b2CUser: null | B2CAuthUser;
  accessToken: string | null;
  refreshToken: string | null;
  expiresIn: number | undefined;
  setB2cAuth: (token: string, user: B2CAuthUser, refreshToken?: string, expiresIn?: number) => void;
  lastLoginMethod: string;
  setLastLoginMethod: (lastLoginMethod: string)=>void;
  travelers: any[];
  setTravelers: (travelers: any[]) => void;
  clearTravelers: () => void;
}

export const useAuthStore = create<AuthStoreState>((set) => ({
  isLoggedIn: false,
  showAuthModal: false,
  showOTPModal: false,
  creditApplied: false,
  creditAmount: 0,
  creditLoading: false,
  creditDetails: null,
  setAuthModal: (show: boolean) => set({ showAuthModal: show }),
  setOTPModal: (show: boolean) => set({ showOTPModal: show }),
  login: () =>
    set({ isLoggedIn: true, showOTPModal: false, showAuthModal: false }),
  logout: () => {
    set({
      isLoggedIn: false,
      creditApplied: false,
      creditAmount: 0,
      creditDetails: null,
      b2CUser: null,
      accessToken: "",
      refreshToken: "",
      expiresIn: undefined,
      travelers: [],
    });
    window.parent.postMessage({ type: "TRIPS_LOGOUT" }, "*");
    redirectHome();
  },
  setCreditLoading: (loading: boolean) => set({ creditLoading: loading }),
  setCreditAppliedDetails: (details: ApplyCreditResponse) =>
    set({
      creditApplied: true,
      creditDetails: details,
      creditAmount: details.Amount,
    }),
  clearCreditDetails: () =>
    set({ creditApplied: false, creditDetails: null, creditAmount: 0 }),
  removeCredit: () =>
    set({ creditApplied: false, creditDetails: null, creditAmount: 0 }),
  // Set last login value, wallet balance and logged in user details
  accessToken: "",
  refreshToken: "",
  b2CUser: null,
  expiresIn: undefined,
  setB2cAuth: (token: string, b2CUser: B2CAuthUser, refreshToken?: string, expiresIn?: number) =>
    set((state) => ({
      accessToken: token,
      b2CUser,
      ...(refreshToken !== undefined ? { refreshToken } : {}),
      ...(expiresIn !== undefined ? { expiresIn } : {}),
    })),
  lastLoginMethod: "",
  setLastLoginMethod: (lastLoginMethod: string) => set({ lastLoginMethod }),
  travelers: [],
  setTravelers: (travelers: any[]) => set({ travelers }),
  clearTravelers: () => set({ travelers: [] }),
}));
